// extracted by mini-css-extract-plugin
export default {"backLink":"PP5itYYNf2jepBjSusAr"};